import React from "react";
import styles from "./ChoosingUs.module.css";
import experience from "../../assets/home/experience.png";
import communication from "../../assets/home/communication.png";
import comfort from "../../assets/home/comfort.png";

const ChoosingUs = () => {
  return (
    <div style={{ backgroundColor: "#fff1e5" }}>
      <div className="container overflow-hidden">
        <p
          data-aos="slide-right"
          data-aos-offset="220"
          className={styles.heading}
        >
          Top three the reason why you should choose us.
        </p>
        <p data-aos="slide-left" className={styles.sub_text}>
          Unified group delivering purposeful innovation, excellence, trust, and
          integrated solutions across industries.
        </p>
        <div className={`row ${styles.sub}`}>
          <div data-aos="fade-right" className="col-md-4">
            <img src={experience} alt="experience" />
            <p className={styles.logo_head}>One Group. Multiple Strengths.</p>
            <p className={styles.logo_text}>
              SNEW GROUP unites multiple industries including technology, media,
              logistics, events, food products, electronics, real estate, and
              interiors to deliver seamless integrated solutions globally.
            </p>
          </div>

          <div data-aos="fade" className="col-md-4">
            <img src={communication} alt="experience" />
            <p className={styles.logo_head}>Innovation Driven by Purpose.</p>
            <p className={styles.logo_text}>
              We don’t follow trends we create impact every venture is driven by
              innovation efficiency and a strong purpose to deliver meaningful
              value that endures.
            </p>
          </div>

          <div data-aos="fade-left" className="col-md-4">
            <img src={comfort} alt="experience" />
            <p className={styles.logo_head}>Trust Built on Excellence.</p>
            <p className={styles.logo_text}>
              Our commitment to quality transparency and timely delivery has
              built lasting trust fostered partnerships and consistently
              delivered reliable results across diverse industries worldwide.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChoosingUs;
